import axios from 'axios'

export default {
    methods: {
        dataDogIncrement(metric, tags = []) {
            axios.post('/api/datadog/increment', { metric, tags })
        }
    }
}

